import React, { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { downloadCsv } from "@/lib/download";

export function ExportButton({ kind, orgId, label = "Exporter CSV", testid }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await downloadCsv(kind, orgId);
    } catch {
      toast.error("Export impossible pour le moment.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      onClick={go}
      disabled={busy || !orgId}
      data-testid={testid}
      className="flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:bg-slate-50 disabled:opacity-50"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {label}
    </button>
  );
}
